import { render, staticRenderFns } from "./modalItemInfo.vue?vue&type=template&id=14445102&scoped=true&"
import script from "./modalItemInfo.vue?vue&type=script&lang=js&"
export * from "./modalItemInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14445102",
  null
  
)

export default component.exports